import * as ProgressPrimitive from '@radix-ui/react-progress';

import { cn } from '../../utils/cn';

/**
 * Linear progress bar. Wraps Radix Progress for a11y.
 */
export function ProgressBar({ value = 0, max = 100, className, tone = 'sage' }) {
  const safeMax = max > 0 ? max : 100;
  const pct = Math.min(100, Math.max(0, (value / safeMax) * 100));

  const tones = {
    sage: 'bg-gradient-to-r from-sage-500 to-sage-600',
    success: 'bg-gradient-to-r from-success-500 to-success-700',
    warning: 'bg-warning-500',
    danger: 'bg-danger-500',
  };

  return (
    <ProgressPrimitive.Root
      value={pct}
      max={100}
      className={cn('relative h-2 w-full overflow-hidden rounded-full bg-track', className)}
    >
      <ProgressPrimitive.Indicator
        className={cn('h-full transition-all duration-300', tones[tone] || tones.sage)}
        style={{ width: `${pct}%` }}
      />
    </ProgressPrimitive.Root>
  );
}
